import React, { useRef, useState, useEffect } from 'react'
import { PrismicRichText } from '@prismicio/react'

import {
  getStorageString,
  setStorageString,
  StorageKey,
} from '../../util/storage'

import * as Styled from './styles/CookieBanner.styles'

const CookieBanner = ({ copy, isNavMenuOpen }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [willRemoveElement, setWillRemoveElement] = useState(false)

  const timer = useRef(null)

  const hasClosedCookiePopup = getStorageString({
    key: StorageKey.HAS_CLOSED_COOKIE_POPUP,
  })

  useEffect(() => {
    if (!hasClosedCookiePopup && !isVisible) {
      setIsVisible(true)
    }
  }, [getStorageString, isVisible, setIsVisible])

  useEffect(() => {
    if (hasClosedCookiePopup) {
      timer.current = setTimeout(() => {
        setWillRemoveElement(true)
      }, 250)
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
        timer.current = undefined
      }
    }
  }, [hasClosedCookiePopup, setWillRemoveElement])

  const handleOnCookieClose = () => {
    setStorageString({
      key: StorageKey.HAS_CLOSED_COOKIE_POPUP,
      value: true,
    })

    setIsVisible(false)
  }

  if (willRemoveElement) {
    return null
  }

  return (
    <Styled.Container isNavMenuOpen={isNavMenuOpen} isVisible={isVisible}>
      <Styled.TextContainer>
        <PrismicRichText field={copy.richText} />
      </Styled.TextContainer>
      <Styled.Button onClick={handleOnCookieClose}>
        <Styled.ButtonLabel>OK</Styled.ButtonLabel>
      </Styled.Button>
    </Styled.Container>
  )
}

export default CookieBanner
